import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { formatDateTime } from "utilities/formatDateTime";

type UserActivityProps = { time: string; user: { userName: string; userId: string } };

const UserActivity: React.FC<UserActivityProps> = (props) => {
  const { time, user } = props;

  return (
    <>
      <Typography fontSize="small">
        <Link component={RouterLink} to={`/users/view/${user.userId}`}>
          {user.userName}
        </Link>
      </Typography>

      <Typography fontSize="small" color="text.secondary">
        {formatDateTime(time)}
      </Typography>
    </>
  );
};

export default UserActivity;
